/* eslint-disable no-console */
// process.env.NODE_ENV === "production";

import { register } from "register-service-worker";
import store from "./store";
import { subscriberCollection, messaging } from "./firebase-config";

let token;
let registration;
// const x = true;

if (process.env.NODE_ENV === "production" && messaging) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready(reg) {
      registration = reg;
      checkIfPushIsEnabled(registration);
      messaging.onTokenRefresh(() => {
        messaging
          .getToken()
          .then(refreshedToken => {
            console.log("Token refreshed.");
            // Indicate that the new Instance ID token has not yet been sent to the app server.
            token = refreshedToken;
            setTokenSentToServer(false);
            // Send Instance ID token to app server.
            sendSubscriptionIDToServer();
          })
          .catch(err => {
            console.error("Unable to retrieve refreshed token ", err);
          });
      });
    },
    // registered() {
    //   console.log("Service worker has been registered.");
    // },
    // cached() {
    //   console.log("Content has been cached for offline use.");
    // },
    // updatefound() {
    //   console.log("New content is downloading.");
    // },
    // updated() {
    //   console.log("New content is available; please refresh.");
    // },
    // offline() {
    //   console.log(
    //     "No internet connection found. App is running in offline mode."
    //   );
    // },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}

const checkIfPushIsEnabled = registration => {
  //---check if push notification permission
  // has been denied by the user---
  if (Notification.permission === "denied") {
    alert("User has blocked push notification.");
    return;
  }
  //---check if push notification is
  // supported or not---
  if (!("PushManager" in window)) {
    alert("Sorry, Push notification is not supported on this browser.");
    return;
  }
  //---get push notification subscription
  // if serviceWorker is registered and ready---
  registration.pushManager
    .getSubscription()
    .then(subscription => {
      if (subscription) {
        //---user is currently subscribed to push---
        getToken();
      } else {
        //---user is not subscribed to push---
        updatePushNotificationStatus(false);
      }
    })
    .catch(error => {
      console.error("Error occurred enabling push ", error);
    });
};

// ---Update the Push Notification Status---
const updatePushNotificationStatus = status => {
  if (status) {
    store.dispatch("setNotificationStatus", true);
  } else {
    store.dispatch("setNotificationStatus", false);
  }
};

// ---subscribe to push notification---
export const subscribeToPushNotification = async () => {
  if (!registration.pushManager) {
    alert("This browser does not support push notification.");
    return false;
  }
  //---to subscribe push notification using pushmanager---
  const applicationServerKey = urlB64ToUint8Array(
    "BKU2Qpwf5zeB1DbB71jcCI2cxTRd5Wf_0Ghk82XBt8SSog0lOy2BQOwWT1hMDr1RF5iips7LsTeTh5uEqmn4Kas"
  );
  try {
    const subscription = await registration.pushManager.subscribe(
      //---always show notification when received---
      { applicationServerKey, userVisibleOnly: true }
    );
    //------add the following statement------
    if (token) {
      await sendSubscriptionIDToServer(subscription, token);
    } else {
      await getToken();
    }
    //---------------------------------------
    updatePushNotificationStatus(true);
  } catch (error) {
    updatePushNotificationStatus(false);
    console.error("Push notification subscription error: ", error);
  }
};

//---unsubscribe from push notification---
export const unsubscribeFromPushNotification = async () => {
  try {
    const subscription = await registration.pushManager.getSubscription();
    if (!subscription) return;
    await subscription.unsubscribe();
    await messaging.deleteToken(token);
    await deleteSubscriptionIDToServer(subscription);
    updatePushNotificationStatus(false);
  } catch (error) {
    console.error("Failed to unsubscribe push notification. " + error);
  }
};

const sendSubscriptionIDToServer = async (subscription, token) => {
  let subscriptionArray = subscription.endpoint.split("/");
  let subscriptionID = subscriptionArray[subscriptionArray.length - 1];
  if (!isTokenSentToServer()) {
    subscriberCollection.doc(subscriptionID).set({
      notificationToken: token
    });
  }
  setTokenSentToServer(true);
};

const deleteSubscriptionIDToServer = async subscription => {
  let subscriptionArray = subscription.endpoint.split("/");
  let subscriptionID = subscriptionArray[subscriptionArray.length - 1];
  await subscriberCollection.doc(subscriptionID).delete();
  setTokenSentToServer(false);
};

//convert public id to server key
const urlB64ToUint8Array = base64String => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

const getToken = async () => {
  try {
    const currentToken = await messaging.getToken();
    if (currentToken) {
      token = currentToken;
      await subscribeToPushNotification();
    } else {
      // Show permission request.
      console.log(
        "No Instance ID token available. Request permission to generate one."
      );
      setTokenSentToServer(false);
    }
  } catch (err) {
    console.error("An error occurred while retrieving token. ", err);
  }
};

const isTokenSentToServer = () => {
  return window.localStorage.getItem("sentToServer") === "1";
};

const setTokenSentToServer = sent => {
  window.localStorage.setItem("sentToServer", sent ? "1" : "0");
};
